import { getCurrentUser, signIn, signUp, signOut, confirmSignUp, resetPassword, confirmResetPassword, signInWithRedirect, fetchAuthSession, resendSignUpCode } from 'aws-amplify/auth'

export const authService = {
  async getCurrentUser() {
    try {
      const user = await getCurrentUser()
      const session = await fetchAuthSession()
      return { ...user, session }
    } catch (error) {
      return null
    }
  },

  async signIn(email: string, password: string) {
    const result = await signIn({ 
      username: email, 
      password 
    })
    return result
  },

  async signInWithRedirect(provider: 'Google' | 'Facebook') {
    await signInWithRedirect({ provider: { custom: provider } })
  },

  async signUp(email: string, password: string, attributes: Record<string, string>) {
    const result = await signUp({
      username: email,
      password,
      options: { 
        userAttributes: { 
          email, 
          ...attributes 
        } 
      }
    })
    return result
  },

  async confirmSignUp(email: string, confirmationCode: string) {
    const result = await confirmSignUp({ 
      username: email, 
      confirmationCode 
    })
    return result
  },

  async resendSignUpCode(email: string) {
    const result = await resendSignUpCode({
      username: email
    })
    return result
  },

  async signOut() {
    await signOut()
  },

  async resetPassword(email: string) {
    const result = await resetPassword({ username: email })
    return result
  },

  async confirmResetPassword(email: string, confirmationCode: string, newPassword: string) {
    const result = await confirmResetPassword({ 
      username: email, 
      confirmationCode, 
      newPassword 
    })
    return result
  },

  async getSession() {
    try {
      const session = await fetchAuthSession()
      return session
    } catch (error) {
      return null
    }
  }
}